import useCmsRouteParams from '../../src/global-state/cmsRouteParams/useCmsRouteParams';
const useParamsMock = () => {
  const params = useCmsRouteParams();
  return params;
};
export default useParamsMock;